export const GET_INFO = 'GET_INFO';
export const GET_MEDIA = 'GET_MEDIA';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_PROFILES = 'GET_PROFILES';